export default "__VITE_ASSET__c5c7fa51__"